export default function Hero() {
  const stats = [
    { value: '200+', label: '日均更新', desc: '条新鲜爆料' },
    { value: '7×24h', label: '全天候', desc: '不间断追踪' },
    { value: '安全', label: '官方通道', desc: '稳定访问保障' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[650px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/40 via-background-50 to-accent-50/30"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-100 text-primary-700 text-sm font-medium rounded-full mb-5 whitespace-nowrap">
              <i className="ri-fire-line text-base"></i>
              官方认证入口
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight mb-4">
              吃瓜网51
              <span className="block text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground-700 mt-2">
                一站式娱乐资讯聚合平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-heading font-medium mb-5">
              最新、最快、最全的娱乐圈动态，尽在吃瓜网51
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              吃瓜网51官网版是集娱乐资讯、明星动态、影视热点于一体的综合性吃瓜平台。我们全天候追踪娱乐圈最新爆料，为您提供安全稳定的网页版与正式版访问入口，确保您第一时间直达官方爆料平台。无论您关注明星八卦、热播剧评、综艺花絮还是时尚潮流，这里都有您想看的精彩内容。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              {stats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-3 bg-background-100/80 rounded-xl px-4 py-3">
                  <span className="text-xl md:text-2xl font-heading font-bold text-primary-600 whitespace-nowrap">
                    {stat.value}
                  </span>
                  <div className="text-left">
                    <span className="block text-xs md:text-sm font-medium text-foreground-800 whitespace-nowrap">
                      {stat.label}
                    </span>
                    <span className="block text-xs text-foreground-500 whitespace-nowrap">
                      {stat.desc}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-center text-sm"
              >
                <i className="ri-flashlight-line mr-2"></i>
                立即浏览
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 border border-secondary-300 text-foreground-700 font-medium rounded-lg hover:bg-secondary-50 transition-colors duration-200 whitespace-nowrap cursor-pointer text-center text-sm"
              >
                <i className="ri-information-line mr-2"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20artistic%20abstract%20composition%20representing%20entertainment%20news%20media%20flow%20with%20warm%20coral%20amber%20tones%20flowing%20geometric%20shapes%20on%20cream%20background%20sophisticated%20editorial%20style%20soft%20gradients%20harmonious%20composition%20digital%20art&width=700&height=525&seq=hero-main-visual&orientation=landscape"
                alt="吃瓜网51官方首页入口 - 娱乐资讯聚合平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}